<template>
  <div v-if="isShow.isPFShow" class="pg4">
    <Nav @nav="handleNav" :activeNum="4" />
    <div class="pg4-title"></div>
    <div class="pg4-article-title1">
      <img src="./img/pg4-article-title1-inner.png" alt="">
    </div>
    <div class="pg4-article1">
      <div class="pg4-article-text1"></div>
      <div class="slider-wrapper1">
        <slider :imgCollection="slidesCollection" />
      </div>
      <div class="slider-wrapper2">
        <slider :imgCollection="slidesCollection2" />
      </div>
    </div>
    <div class="pg4-article-title2">
      <img src="./img/pg4-article-title2-inner.png" alt="">
    </div>
    <div class="pg4-article2">
      <div class="pg4-article2-c1"></div>
      <div class="c2-title-wp">
        <div class="sprites2"></div>
        <span class="c2-txt">最佳制作奖</span>
      </div>
      <div class="pg4-article2-c2"></div>
      <div class="c3-title-wp">
        <div class="sprites2"></div>
        <span class="c3-txt">优秀画面奖</span>
      </div>
      <div class="pg4-article2-c3"></div>
      <div class="c4-title-wp">
        <div class="sprites2"></div>
        <span class="c4-txt">优秀创意奖</span>
      </div>
      <div class="pg4-article2-c4"></div>
    </div>
    <div class="pg4-article-title3">
      <img src="./img/pg4-article-title3-inner.png" alt="">
    </div>
    <div class="pg4-article3">
      <div class="pg4-article-c1">
        <div class="pg4-article-t1"></div>
        <div class="vd-wp1">
          <vd-player :src="src1" :poster="poster1"/>
        </div>
      </div>
      <div class="pg4-article-c2">
        <div class="pg4-article-t2"></div>
        <div class="vd-wp2">
          <vd-player :src="src2" :poster="poster2" />
        </div>
      </div>
      <div class="pg4-article-c3">
        <div class="pg4-article-t3"></div>
        <div class="vd-wp3">
          <vd-player :src="src3" :poster="poster3" />
        </div>
      </div>
      <div class="pg4-article-c4">
        <div class="pg4-article-t4"></div>
        <div class="vd-wp4">
          <vd-player :src="src4" :poster="poster4" />
        </div>
      </div>
      <div class="pg4-article-c5">
        <div class="pg4-article-t5"></div>
        <div class="vd-wp5">
          <vd-player :src="src5" :poster="poster5" />
        </div>
      </div>
      <div class="pg4-article-c6">
        <div class="pg4-article-t6"></div>
        <div class="vd-wp6">
          <vd-player :src="src6" :poster="poster6" />
        </div>
      </div>
    </div>
    <div class="pg4-article-title4">
      <img src="./img/pg4-article-title4-inner.png" alt="">
    </div>
    <div class="pg4-article4">
      <div class="pg4-article4-c1"></div>
      <div class="pg4-article4-c2"></div>
      <div class="pg4-article4-c3"></div>
      <div class="vd-wp7">
        <div class="sprites"></div>
        <div class="vd-wp7-up">
          <span class="wp7-txt">节目视频快播</span>
        </div>
        <vd-player :src="src7" :poster="poster7" />
        <div class="vd-wp7-down"></div>
      </div>
      <div class="vd-wp8">
        <div class="sprites"></div>
        <div class="vd-wp8-up">
          <span class="wp8-txt">《寄语70周年》</span>
        </div>
        <vd-player :src="src8" :poster="poster8" />
        <div class="vd-wp8-down"></div>
      </div>
    </div>
    <div class="bg-bottom">
      <div class="bg-bottom-inner">
        <div class="btn-wp" @click="vote">
          <span class="icon-thumb"></span>
          <span class="btn-num">{{num}}</span>
        </div>
        <p class="btn-desc">点赞</p>
        <div class="btn-back" @click="goBack">返回</div>
      </div>
    </div>
    <toast :toastMsg="msg" :ms="time" :isTrigger="trigger" />
  </div>
</template>

<script>
import Slider from '../../components/slider/slider';
import Nav from '../../components/navBar/navBar'
import { postData } from '../../assets/util'
import Toast from '../../components/toast/toast'
import vdPlayer from '../../components/vd-player/vdPlayer'

export default {
  name: 'PageFour',
  props: {
    isShow: Object
  },
  data() {
    return {
      num: 0,
      trigger: false,
      msg: '',
      time: 1500,
      src1: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-1.mp4',
      src2: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-2.mp4',
      src3: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-3.mp4',
      src4: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-4.mp4',
      src5: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-5.mp4',
      src6: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-6.mp4',
      src7: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-7.mp4',
      src8: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/videos/p4-8.mp4',
      poster1: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-1.jpg',
      poster2: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-2.jpg',
      poster3: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-3.jpg',
      poster4: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-4.jpg',
      poster5: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-5.jpg',
      poster6: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-6.jpg',
      poster7: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-7.jpg',
      poster8: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/poster/p4-8.jpg',
      slidesCollection: [{
        src: require('../page-one/img/p4-c1-p1.jpg'),
      }, {
        src: require('../page-one/img/p4-c1-p2.jpg'),
      }, {
        src: require('../page-one/img/p4-c1-p3.jpg'),
      }, {
        src: require('../page-one/img/p4-c1-p4.jpg'),
      }, {
        src: require('../page-one/img/p4-c1-p5.jpg'),
      }],
      slidesCollection2: [{
        src: require('../page-one/img/p4-c2-p1.jpg'),
      }, {
        src: require('../page-one/img/p4-c2-p2.jpg'),
      }, {
        src: require('../page-one/img/p4-c2-p3.jpg'),
      }, {
        src: require('../page-one/img/p4-c2-p4.jpg'),
      }],
    }
  },
  components: {
    Slider,
    Nav,
    Toast,
    'vd-player': vdPlayer
  },
  methods: {
    goBack() {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow')
      }, 300)
    },
    handleNav(msg) {
      this.$emit('nextPage', msg);
    },
    notify(msg, time) {
      this.trigger = !this.trigger;
      this.msg = msg || '';
      this.time = time || 1500;
    },
    getNumber() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_articleZan';
      const myData = {articleId: 3};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            let tempNum = parseInt(res.zanNum);
            this.num = tempNum;
          } else {
            const txt = res.msg || '获取失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('获取出错')
        })
    },
    vote() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_zan';
      const myData = {articleId: 3};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            this.notify('点赞成功');
            this.num += 1;
          } else {
            const txt = res.msg || '点赞失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('点赞出错')
        })
    },
  },
  watch: {
    'isShow.isPFShow': function () {
      window.scroll(0, 0);
      setTimeout(() => {
        if (this.isShow.isPFShow) {
          const title = document.querySelector('.vd-wp7');
          const title2 = document.querySelector('.vd-wp8');
          const sub = title.querySelector('.sprites')
          const sub2 = title2.querySelector('.sprites')

          const upTitle1 = document.querySelector('.c2-title-wp');
          const upTitle2 = document.querySelector('.c3-title-wp');
          const upTitle3 = document.querySelector('.c4-title-wp');
          const upSub1 = upTitle1.querySelector('.sprites2');
          const upSub2 = upTitle2.querySelector('.sprites2');
          const upSub3 = upTitle3.querySelector('.sprites2');
          window.addEventListener('scroll', () => {
            if (this.isShow.isPFShow) {
              const dis = title.getBoundingClientRect().top;
              const dis2 = upTitle1.getBoundingClientRect().top;
              if (dis < 500) {
                title.classList.add('wp7-play');
                setTimeout(() => {
                  sub.classList.add('hide');
                }, 1000)
              }
              if (dis < 450) {
                title2.classList.add('wp8-play');
                setTimeout(() => {
                  sub2.classList.add('hide');
                }, 1000);
              }
              if (dis2 < 500) {
                upTitle1.classList.add('c2-title-play');
                setTimeout(() => {
                  upSub1.classList.add('hide');
                }, 1000)
              }
              if (dis2 < 150) {
                upTitle2.classList.add('c3-title-play');
                setTimeout(() => {
                  upSub2.classList.add('hide');
                }, 1000)
              }
              if (dis2 < -100) {
                upTitle3.classList.add('c4-title-play');
                setTimeout(() => {
                  upSub3.classList.add('hide');
                }, 1000)
              }
            }
          })
          title.classList.remove('wp7-play');
          title2.classList.remove('wp8-play');
          sub.classList.remove('hide')
          sub2.classList.remove('hide')
          upSub1.classList.remove('hide')
          upSub2.classList.remove('hide')
          upSub3.classList.remove('hide')
        }
      }, 200)
    }
  },
  created() {
    this.getNumber();
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg4 {
  box-sizing: border-box;
  padding-top: 1.875rem /* 30/16 */;
  min-height: 100vh;
  background-color: #012bad;
}
.pg4-title {
  width: 23.4375rem /* 375/16 */;
  height: 21.25/2rem /* 340/16 */;
  .bg('./img/pg4-title.png');
}
.pg4-article-title1 {
  margin: 0 auto;
  margin-bottom: .625rem /* 10/16 */;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 10.6875/2rem /* 171/16 */;
    height: 2.5625/2rem /* 41/16 */;
  }
}
.pg4-article1 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 2.5rem /* 40/16 */;
  margin: 0 auto;
  width: 42.8125/2rem /* 685/16 */;
  height: 78.125/2rem /* 1250/16 */;
  .bg('./img/pg4-article1-bg.png');
}
.slider-wrapper1, .slider-wrapper2 {
  position: absolute;
  left: 1.6rem;
  box-sizing: border-box;
  width: 36.9375/2rem /* 591/16 */;
  height: 24.375/2rem /* 390/16 */;
  border-radius: .5rem /* 8/16 */;
  overflow: hidden;
}
.slider-wrapper1 {
  bottom: 16rem;
}
.slider-wrapper2 {
  bottom: 2rem;
}
.pg4-article-text1 {
  width: 36.3125/2rem /* 581/16 */;
  height: 12.75/2rem /* 204/16 */;
  .bg('./img/pg4-article-text1.png');
}
.pg4-article-title2 {
  margin: .625rem /* 10/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 15.3125/2.2rem /* 245/16 */;
    height: 2.6875/2.2rem /* 43/16 */;
  }
}
.pg4-article2 {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 2.5rem /* 40/16 */;
  width: 42.8125/2rem /* 685/16 */;
  height: 144.6875/2rem /* 2315/16 */;
  .bg('./img/pg4-article2.png');
  overflow: hidden;
}
.pg4-article2-c1 {
  width: 36.1875/2rem /* 579/16 */;
  height: 18/2rem /* 288/16 */;
  margin-bottom: 1.25rem /* 20/16 */;
  .bg('./img/pg4-article2-c1.png');
}
.pg4-article2-c2 {
  width: 41.6875/2rem /* 667/16 */;
  height: 38.375/2rem /* 614/16 */;
  .bg('./img/pg4-article2-c2.png');
}
.pg4-article2-c3 {
  width: 41.6875/2rem /* 667/16 */;
  height: 26.25/2rem /* 420/16 */;
  .bg('./img/pg4-article2-c3.png');
}
.pg4-article2-c4 {
  width: 41.6875/2rem /* 667/16 */;
  height: 13.75rem /* 220/16 */;
  .bg('./img/pg4-article2-c4.png');
}
// 标题
.c3-title-wp, .c4-title-wp, .c2-title-wp {
  position: relative;
  height: 3.125rem /* 50/16 */;
  line-height: 3.125rem /* 50/16 */;
  text-align: center;
}
.c3-txt, .c4-txt, .c2-txt {
  color: #96fbff;
  text-shadow: 0 0 10px white;
  opacity: 0;
  transition: all .3s ease-out 1s;
}
.pg4-article-title3 {
  margin: .625rem /* 10/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 20.6875/2.2rem /* 331/16 */;
    height: 2.8125/2.2rem /* 45/16 */;
  }
}
.pg4-article3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 2.5rem /* 40/16 */ 0 3.125rem /* 50/16 */;
  margin: 0 auto;
  margin-bottom: 1.875rem /* 30/16 */;
  width: 41.875/2rem /* 670/16 */;
  height: 162.4375/2rem /* 2599/16 */;
  .bg('./img/pg4-article3-bg.png');
}
.pg4-article-c1, .pg4-article-c2, .pg4-article-c3, .pg4-article-c4, .pg4-article-c5, .pg4-article-c6 {
  position: relative;
}
.pg4-article-t1 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h1.png');
}
.pg4-article-t2 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h2.png');
}
.pg4-article-t3 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h3.png');
}
.pg4-article-t4 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h4.png');
}
.pg4-article-t5 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h5.png');
}
.pg4-article-t6 {
  box-sizing: border-box;
  width: 42.375/2rem /* 678/16 */;
  height: 4.625/2rem /* 74/16 */;
  .bg('./img/pg4-article3-h6.png');
}
.pg4-article-title4 {
  margin: .625rem /* 10/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 20.25/2.2rem /* 324/16 */;
    height: 2.8125/2.2rem /* 45/16 */;
  }
}
.pg4-article4 {
  box-sizing: border-box;
  padding-top: 3.125rem /* 50/16 */;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 3.125rem /* 50/16 */;
  width: 42.25/2rem /* 676/16 */;
  height: 141/2rem /* 2256/16 */;
  .bg('./img/pg4-article4-bg.png');
  overflow: hidden;
}
.pg4-article4-c1 {
  width: 36.0625/2rem /* 577/16 */;
  height: 9.6875/2rem /* 155/16 */;
  .bg('./img/pg4-article4-text1.png');
}
.pg4-article4-c2 {
  width: 40.25/2rem /* 644/16 */;
  height: 23.4375/2rem /* 375/16 */;
  .bg('./img/pg4-article-text2.png');
}
.pg4-article4-c3 {
  width: 36.0625/2rem /* 577/16 */;
  height: 28.9375/2rem /* 463/16 */;
  .bg('./img/pg4-article-text3.png');
}
.bg-bottom {
  width: 23.4375rem /* 375/16 */;
  height: 43.1875/2rem /* 691/16 */;
  background: linear-gradient(to bottom, #012bad 1%, #5d46ac 40%, #a95ece 99%);
  .bg-bottom-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    .bg('../page-two/img/p2-bottom-bg.png');
  }
}
.btn-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffcb04 1%, #faa711 50%, #fe9c21 100%);
  box-shadow: 0 0 6px 0 #5e50a3;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
.icon-thumb {
  display: inline-block;
  width: 7.125/2rem /* 114/16 */;
  height: 7.25/2rem /* 116/16 */;
  margin-top: .375rem /* 6/16 */;
  .bg('../page-two/img/pg2-thumb.png');
}
.btn-num {
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
}
.btn-desc {
  margin: 1rem 0;
  color: #fff;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
}
.btn-back {
  box-sizing: border-box;
  width: 9.375rem /* 150/16 */;
  border-radius: 1.875rem /* 30/16 */;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
  line-height: 2;
  text-align: center;
  border: 1px solid #fff;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
@keyframes titleAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3663px;
  }
}
.vd-wp1, .vd-wp2, .vd-wp3, .vd-wp4, .vd-wp5, .vd-wp6 {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 .25rem /* 4/16 */;
  height: 10.5rem /* 168/16 */;
  overflow: hidden;
  margin-top: -.25rem /* 4/16 */;
}
.vd-wp7, .vd-wp8 {
  position: relative;
  margin: 1.25rem /* 20/16 */ 0;
}
.vd-wp8-up, .vd-wp8-down, .vd-wp7-up, .vd-wp7-down {
  width: 300px;
  height: 3.125/2rem /* 50/16 */;
  .bg('../page-three/img/film-wp-part.png');
  text-align: center;
  line-height: 1.5625rem /* 25/16 */;
}
.wp7-txt, .wp8-txt {
  color: white;
  text-shadow: 0 0 8px white;
  opacity: 0;
  transition: all .3s ease-out 1s;
}
.sprites {
  position: absolute;
  z-index: 5;
  top: -12.5rem /* 200/16 */;
  left: -3.75rem /* 60/16 */;
  width: 416.66px;
  height: 450px;
  background-image: url('./img/sprite.png');
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity .1s;
}
.sprites2 {
  position: absolute;
  z-index: 5;
  top: -11.25rem /* 180/16 */;
  left: -10.625rem /* 170/16 */;
  width: 416.66px;
  height: 450px;
  background-image: url('./img/sprite.png');
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity .1s;
}
.c2-title-play{
  .sprites2 {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .c2-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.c3-title-play{
  .sprites2 {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .c3-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.c4-title-play{
  .sprites2 {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .c4-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.wp7-play {
  .sprites {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .wp7-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.wp8-play {
  .sprites {
    opacity: 1;
    animation: particle 1s steps(6);
    animation-fill-mode: both;
  }
  .wp8-txt {
    text-shadow: 0 0 1px white;
    opacity: 1;
  }
}
.hide {
  display: none;
}
@keyframes particle {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2500px;
  }
}
</style>
